import React from 'react';
import { View, Text, ScrollView, StyleSheet, TouchableOpacity } from 'react-native-web';
import { useNavigate } from 'react-router-dom';

const TermsConditions = () => {
  const navigate = useNavigate();

  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}>
      <TouchableOpacity dataSet={{ hover: "lift" }} onPress={() => navigate(-1)} style={styles.backButton}>
        <Text style={styles.backButtonText}>← Back</Text>
      </TouchableOpacity>
      
      <Text style={styles.title}>SMS Terms and Conditions</Text>
      
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>1. Program Description</Text>
        <Text style={styles.text}>
          Bonita Bikes sends text messages to customers for booking confirmations, rental status updates, payment receipts, and customer support inquiries.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>2. Message Cancellation</Text>
        <Text style={styles.text}>
          You can cancel the SMS service at any time. Just text "STOP" to the short code. After you send the SMS message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time and we will start sending SMS messages to you again.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>3. Help Instructions</Text>
        <Text style={styles.text}>
          If you are experiencing issues with the messaging program you can reply with the keyword HELP for more assistance, or you can get help directly at help@bonitabikes.com.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>4. Carrier Liability</Text>
        <Text style={styles.text}>
          Carriers are not liable for delayed or undelivered messages.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>5. Message and Data Rates</Text>
        <Text style={styles.text}>
          As always, message and data rates may apply for any messages sent to you from us and to us from you. You will receive messages based on your activity with our service (e.g., new booking, check-in, check-out). If you have any questions about your text plan or data plan, it is best to contact your wireless provider.
        </Text>
      </View>
      
       <View style={styles.section}>
        <Text style={styles.sectionTitle}>6. Privacy</Text>
        <Text style={styles.text}>
          If you have any questions regarding privacy, please read our privacy policy.
        </Text>
      </View>
      
      <View style={styles.footer}>
        <Text style={styles.footerText}>Last Updated: December 2025</Text>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  contentContainer: {
    padding: 20,
    maxWidth: 800,
    alignSelf: 'center',
    width: '100%',
  },
  backButton: {
    marginBottom: 20,
    padding: 10,
  },
  backButtonText: {
    color: '#0E7C6B',
    fontSize: 16,
    fontWeight: '600',
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 24,
    color: '#2E3A38',
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 8,
    color: '#2E3A38',
  },
  text: {
    fontSize: 16,
    lineHeight: 24,
    color: '#5C6B68',
  },
  footer: {
    marginTop: 40,
    paddingTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#EDF1F0',
  },
  footerText: {
    fontSize: 14,
    color: '#8A9794',
    textAlign: 'center',
  },
});

export default TermsConditions;
